<div class="d-flex align-items-center justify-content-between">
  <h1>404 Error</h1>
  <h3>Page Not Found</h3>
  <a class="btn btn-primary" href="/">Go To Home</a>
</div>
